import React, { useState, useEffect, useRef } from "react";
import Autoplay from 'embla-carousel-autoplay';
import CardServicosCompacto from "./cardServicosCompacto";
import FormularioRD from "../rdstation/formularioRD";
import { useModal } from "../contexts/ModalContext";
import {
    Carousel,
    CarouselContent,
    CarouselItem,
    CarouselNext,
    CarouselPrevious,
    CarouselButtonsMobile
} from "./carousel";

const servicosData = [
    {
        icon: "../assets/servicos/apoio_icon.svg",
        iconHover: "../assets/servicos/apoio_icon.svg",
        title: "Apoio para escalar de forma sustentável",
        text: "",
        glowColor: "#A800E4",
        url: "",
    },
    {
        icon: "../assets/servicos/cocriacao_icon.svg",
        iconHover: "../assets/servicos/cocriacao_icon.svg",
        title: "Co-criação com especialistas do grupo",
        text: <></>,
        glowColor: "#A800E4",
        url: "",
    },
    {
        icon: "../assets/servicos/estrategia2_icon.svg",
        iconHover: "../assets/servicos/estrategia2_icon.svg",
        title: "Estratégia de mercado e validação real",
        text: <></>,
        glowColor: "#A800E4",
        url: "",
    },
    {
        icon: "../assets/servicos/mentoria_icon.svg",
        iconHover: "../assets/servicos/mentoria_icon.svg",
        title: "Mentoria com sócios experientes",
        text: <></>,
        glowColor: "#A800E4",
        url: "",
    },
    {
        icon: "../assets/servicos/conexao_icon.svg",
        iconHover: "../assets/servicos/conexao_icon.svg",
        title: "Conexão com clientes e investidores",
        text: <></>,
        glowColor: "#A800E4",
        url: "",
    },
    {
        icon: "../assets/servicos/acesso_icon.svg",
        iconHover: "../assets/servicos/acesso_icon.svg",
        title: "Acesso a estrutura de tecnologia, marketing e operação",
        text: <></>,
        glowColor: "#A800E4",
        url: "",
    }
];

export default function DiferenciaisVentures() {
    const [api, setApi] = useState(null);
    const [current, setCurrent] = useState(0);
    const [count, setCount] = useState(0);
    const { openModal } = useModal();
    const scrollRef = useRef(null);
    
    // Calculate number of pages based on items and visible items per page
    const itemsPerPage = 3; // Number of items visible at once
    const totalPages = Math.ceil(servicosData.length / itemsPerPage);
    
    useEffect(() => {
        if (!api) return;
        
        // Update current slide when carousel changes
        const onSelect = () => {
            setCurrent(api.selectedScrollSnap());
        };
        
        api.on("select", onSelect);
        setCount(api.scrollSnapList().length);
        setCurrent(api.selectedScrollSnap());
        
        return () => {
            api.off("select", onSelect);
        };
    }, [api]);
    
    // Function to navigate to a specific slide
    const goToSlide = (index) => {
        if (api) {
            api.scrollTo(index);
        }
    };
    
    return (
        <section className="bg-[url(../assets/cover-diferenciais-ventures.png)] bg-cover py-12 md:py-20 px-4 md:px-24 text-white">
            <div className="container mx-auto">
                <h2 className="font-inter-regular text-4xl md:text-[60px] text-center">
                    Diferenciais
                </h2>
                
                <div className="hidden md:block max-w-6xl mx-auto mt-8">
                    <Carousel setApi={setApi}>
                        <CarouselContent className="items-center px-2 gap-0">
                            {servicosData.map((servico, index) => (
                                <CarouselItem
                                    key={index}
                                    className="basis-1/3 xl:basis-1/4 h-[340px] flex items-center"
                                >
                                    <CardServicosCompacto
                                        {...servico}
                                        width={250}
                                        height={250}
                                    />
                                </CarouselItem>
                            ))}
                        </CarouselContent>
                        <CarouselNext className="hover:cursor-pointer" />
                        <CarouselPrevious className="hover:cursor-pointer" />
                    </Carousel>
                    
                    <div className="flex justify-center gap-2 mt-4">
                        {Array.from({ length: count }).map((_, index) => (
                            <button
                                key={index}
                                onClick={() => goToSlide(index)}
                                className={`${current === index ? 'w-[24px]' : 'w-[8px]'} h-[8px] rounded-full cursor-pointer transition-all duration-300 ${current === index ? 'bg-transparent border border-white' : 'bg-white'}`}
                                aria-label={`Go to slide ${index + 1}`}
                            />
                        ))}
                    </div>
                </div>
                
                <div ref={scrollRef} className="md:hidden mt-8">
                    <Carousel
                        plugins={[
                            Autoplay({
                                delay: 4000,
                            }),
                        ]}
                        className="overflow-visible"
                    >
                        <CarouselContent className="py-2">
                            {servicosData.map((servico, index) => (
                                <CarouselItem key={index}>
                                    <div className="flex justify-center w-full">
                                        <CardServicosCompacto
                                            {...servico}
                                            className="mx-auto scale-90"
                                            width="350"
                                            height="230"
                                        />
                                    </div>
                                </CarouselItem>
                            ))}
                        </CarouselContent>
                        <CarouselButtonsMobile />
                    </Carousel>
                </div>
            </div>
        </section>
    );
}
